module.exports = __webpack_public_path__ + "img/img3.5d32ff5f.png";